import { TEXT_COLORS as TC } from '@constants/colors.ts';
import { BORDER_COLORS as BC } from '@constants/colors.ts';
import { BodySmSmMedium } from '@constants/text.ts';
import { styled } from 'styled-components';

export const CardInfoWrapper = styled.div`
    display: flex;
    padding: 0px var(--spacing-md, 24px);
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    gap: var(--spacing-2xs, 4px);
`;

export const CardInfoTop = styled.div`
    display: flex;
    padding-top: 4px;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
`;

export const CardInfoTitle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: var(--spacing-2xs, 4px);
    align-self: stretch;
    cursor: pointer;
`;

export const CardInfoBookmark = styled.div`
    display: flex;
    padding: 2px 0;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;
`;

const getStatusStyles = (isDueSoon: boolean, isOverdue: boolean, isCompleted: boolean) => {
    let color = TC.body;

    if (isDueSoon) {
        color = BC.warning;
    } else if (isCompleted && !isOverdue) {
        color = TC.success;
    } else if (isOverdue) {
        color = TC.error;
    }

    return `
        color: ${color};

        svg path {
            stroke: ${color};
        }

        ${BodySmSmMedium} {
            color: ${color};
        }
    `;
};

export const CardInfoDate = styled.div<{ $isDueSoon: boolean; $isOverdue: boolean; $isCompleted: boolean }>`
    display: flex;
    height: 27px;
    padding: 6px 11px 6px 0px;
    align-items: center;
    gap: 6px;
    border-radius: var(--border-radius-round, 48px);
    ${({ $isDueSoon, $isOverdue, $isCompleted }) => getStatusStyles($isDueSoon, $isOverdue, $isCompleted)}
`;
